
const MESSAGE = "Tylko 30 abonamentów łącznie we wszystkich trzech wariantach · Sprzedaż w terminie 9–15 listopada";

export const Marquee = () => (
  <div data-testid="sale-marquee" className="overflow-hidden bg-red py-4 text-white" role="note" aria-label={MESSAGE}>
    <div className="marquee flex w-max gap-10" aria-hidden="true">
      {[0, 1].map((k) => (
        <ul key={k} className="flex shrink-0 items-center gap-10">
          {Array.from({ length: 6 }).map((_, i) => (
            <li key={i} className="flex items-center gap-10 whitespace-nowrap font-display text-xl font-medium sm:text-2xl">
              {MESSAGE}
              <span className="h-1.5 w-1.5 bg-white" />
            </li>
          ))}
        </ul>
      ))}
    </div>
  </div>
);
